import { TabMenuBarState } from "app/pages/AgentPricing/modules/TabMenuBar/state";
import { AgentPricingTab } from "app/pages/AgentPricing/actionTypes";

function getRoot(state: any) : TabMenuBarState {
    return state.tabMenuBar;
}

export function getSelectedTab(state: any) : AgentPricingTab {
    return getRoot(state).selectedTab; 
}